<div class="p-grid">
    <div class="p-col-12">
        <div class="title-area">
            <h5 class="head-page-title">
                Edit Club
            </h5>
            <!-- <button pButton pRipple label="Back" icon="pi pi-arrow-left" class="p-button-primary" 
                (click)="backLink()"></button> -->
        </div>
        <div class="card p-pt-3">
            <p-toast key="toastmsg" position="top-right"></p-toast>
            <form [formGroup]="clubForm" *ngIf="this.clubForm" (ngSubmit)="onSubmit()">
                <div class="p-fluid p-formgrid p-grid pare_margin">
                    <div class="p-field p-col-10 div-border">
                        <h5 class="p-mb-3">
                            Edit Club Details
                        </h5>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="name">Name<span class="mandatory-feilds">*</span></label>
                        <input formControlName="name" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                        <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                            <div *ngIf="f.name.errors.required">Name is required</div>
                            <div *ngIf="f.name.errors">Numbers, Space and Special characters not allowed.</div>
                        </div>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="firstRanking">First Ranking Name<span class="mandatory-feilds">*</span></label>
                        <input formControlName="firstRanking" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.firstRanking.errors }">
                        <div *ngIf="submitted && f.firstRanking.errors" class="invalid-feedback">
                            <div *ngIf="f.firstRanking.errors.required">First Ranking Name is required</div>
                            <div *ngIf="f.firstRanking.errors">Numbers, Space and Special characters not allowed.</div>
                        </div>
                    </div>
                    <!-- <div class="p-field p-col-4">
                        <label for="textarea">First Ranking Sport </label>
                        <p-dropdown inputId="firstRankingSport" formControlName="firstRankingSport"
                            [options]="firstRankingSportList" placeholder="Select Sport" optionLabel="name"
                            optionValue="value" (onChange)="onClickFirstRankingSport($event)"
                            [ngClass]="{ 'is-invalid': submitted && f.firstRankingSport.errors }">
                        </p-dropdown>
                        <div *ngIf="submitted && f.firstRankingSport.errors" class="invalid-feedback">
                            <div *ngIf="f.firstRankingSport.errors.required">Please, Select First Ranking Sport</div>
                        </div>
                    </div> -->
                    <div class="p-field p-col-4">
                        <label for="textarea">Type</label>
                        <p-dropdown inputId="type" formControlName="type" [options]="typeArr" placeholder="Select type"
                            optionLabel="name" optionValue="value" (onChange)="onClickType($event)"
                            [ngClass]="{ 'is-invalid': submitted && f.type.errors }">
                        </p-dropdown>
                        <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
                            <div *ngIf="f.type.errors.required">Please, Select Type</div>
                        </div>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-3">
                        <label for="address1">Country<span class="mandatory-feilds">*</span></label>
                        <p-dropdown [style]="{ width: '100%' }" inputId="country" [options]="countriesList"
                            formControlName="country" [filter]="true" placeholder="Select" optionLabel="name"
                            optionValue="code" (onChange)="setCountry($event)"
                            [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                        </p-dropdown>
                        <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                            <div *ngIf="f.country.errors.required">Please Select Country</div>
                        </div>
                    </div>
                    <div class="p-field p-col-3">
                        <label for="address1">State<span class="mandatory-feilds">*</span></label>
                        <p-dropdown [style]="{ width: '100%' }" inputId="state" [options]="stateList"
                            formControlName="state" [filter]="true" placeholder="Select" optionLabel="name"
                            (onChange)="setState($event)" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                        </p-dropdown>
                        <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                            <div *ngIf="f.state.errors.required">Please Select State</div>
                        </div>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="city">City</label>
                        <!-- <select class="custom-select" formControlName="city">
                                                                    <option value="">Choose your City</option>
                                                                    <option *ngFor="let item of cityList" [value]="item.name">{{item.name}}</option>
                                                                </select> -->
                        <p-dropdown inputId="city" [options]="cityList" [filter]="true" formControlName="city"
                            placeholder="Select" optionLabel="name" (onChange)="onCitySelect($event)"></p-dropdown>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-4">
                        <label for="textarea">Address</label>
                        <textarea inputId="textarea" rows="3" cols="30" class="form-control" formControlName="address"
                            pInputTextarea></textarea>
                    </div>
                    <div class="p-field p-col-4">
                        <label for="zipcode">Zipcode</label>
                        <input formControlName="zipcode" type="text" maxlength="10" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.zipcode.errors }">
                    </div>
                    <div class="p-field p-col-4">
                        <label for="status">Status</label>
                        <p-dropdown inputId="status" [options]="statuses" formControlName="status" placeholder="Select"
                            optionLabel="label" (ngModelChange)="onStatusSelect($event)"
                            optionValue="value"></p-dropdown>
                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                            <div *ngIf="f.status.errors.required">Please, Select Status</div>
                        </div>
                    </div>
                </div>

                <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end">
                    <div class="p-formgrid p-grid">
                        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-success p-mr-3"
                            style="width: auto"></button>
                        <!-- <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="clubForm.invalid"></button> -->
                        <!-- <button pButton pRipple label="Reset" icon="pi pi-times" type="reset" (click)="onReset()"
                            style="width: auto" class="p-mr-3"></button> -->
                        <button pButton pRipple type="button" label="Back" class="p-button-info" (click)="backLink()"
                            style="width: auto"></button>
                    </div>
                </div>
            </form>
        </div>
        <div class="button-set back">
            <div class="p-fluid p-formgrid">
                <p-toast></p-toast>
            </div>
        </div>
    </div>
</div>